export interface IOverallPerformance {
    centerId: number,
    centerAlias: string,

    compositeScoreRank: number,
    compositeScoreCategory: string,

    preselectsAverageReviewedRank: number,
    preselectsAverageReviewedCategory: string,

    surgeryDateDeclinesRank: number,
    surgeryDateDeclinesCategory: string,

    swapFailureAnalysisRank: number,
    swapFailureAnalysisCategory: string,

    vxmAnalysisRank: number,
    vxmAnalysisCategory: string,

    chainEndDeclineRatioRank: number,
    chainEndDeclineRatioCategory: string,

    nkrDonorReferralMedianContactTimeRank: number,
    nkrDonorReferralMedianContactTimeCategory: string,

    nkrDonorReferralConversionRateRank: number,
    nkrDonorReferralConversionRateCategory: string,

    missedMatchOfferDeadlineRank: number,
    missedMatchOfferDeadlineCategory: string,

    svDonationsRank: number,
    svDonationsCategory: string,

    fvDonationsRank: number,
    fvDonationsCategory: string,

    kflSuccessRateRank: number,
    kflSuccessRateCategory: string,

    micrositeEnrollmentSuccessRateRank: number,
    micrositeEnrollmentSuccessRateCategory: string,

    micrositePatientReferralSuccessRateRank: number,
    micrositePatientReferralSuccessRateCategory: string,

    voucherDisconnectRank: number,
    voucherDisconnectCategory: string,

    privateLabelVoucherDisconnectRank: number,
    privateLabelVoucherDisconnectCategory: string,

    combinedVoucherDisconnectRank: number,
    combinedVoucherDisconnectCategory: string,

    fiveStarSurveyResultsRank: number,
    fiveStarSurveyResultsCategory: string,

    cprScoreRank: number,
    cprScoreCategory: string,

    overallRan: number
}